import React from 'react';
import Box from '@mui/material/Box';
import { motion, useReducedMotion } from 'framer-motion';

// Lightweight CSS-only stand-in for a 3D scene: blurred gradient "blobs" that
// drift slowly, plus a faint inline-SVG noise overlay. No WebGL, no new deps.
const noiseDataUri =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>";

const defaultBlobs = [
  { size: 460, top: '-12%', left: '-10%', color: 'rgba(253,129,18,0.45)', duration: 16 },
  { size: 380, top: '25%', left: '68%', color: 'rgba(255,95,109,0.32)', duration: 20 },
  { size: 320, top: '68%', left: '2%', color: 'rgba(255,255,255,0.18)', duration: 22 },
];

export default function GradientMeshBackground({ blobs = defaultBlobs, noise = true, sx }) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <Box
      aria-hidden="true"
      sx={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        zIndex: 0,
        pointerEvents: 'none',
        ...sx,
      }}
    >
      {blobs.map((b, i) => (
        <motion.div
          key={i}
          style={{
            position: 'absolute',
            top: b.top,
            left: b.left,
            width: b.size,
            height: b.size,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${b.color} 0%, rgba(0,0,0,0) 70%)`,
            filter: 'blur(50px)',
          }}
          animate={
            prefersReducedMotion ? undefined : { y: [0, 30, 0], x: [0, -20, 0] }
          }
          transition={{ duration: b.duration, repeat: Infinity, ease: 'easeInOut' }}
        />
      ))}
      {noise && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url("${noiseDataUri}")`,
            opacity: 0.035,
            mixBlendMode: 'overlay',
          }}
        />
      )}
    </Box>
  );
}
